import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_API } from 'src/app/tools/URL';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/app/environment';

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  constructor(private http: HttpClient) {}

  listarTiposManifestos() {

    return this.http.get(`${environment.settings.api.url + URL_API.PATH_RELATORIO_TIPOS_MANIFESTOS}`);

  }

  listarUnidades() {

    return this.http.get(`${environment.settings.api.url + URL_API.PATH_RELATORIO_UNIDADES}`);

  }

  listarStatus() {

    return this.http.get(`${environment.settings.api.url + URL_API.PATH_RELATORIO_STATUS}`);

  }

  listarAssuntos() {

    return this.http.get(`${environment.settings.api.url + URL_API.PATH_RELATORIO_ASSUNTOS}`);

  }

  listarAssuntosPorManifesto() {

    return this.http.get(`${environment.settings.api.url + URL_API.PATH_RELATORIO_ASSUNTOS_POR_MANIFESTO}`);

  }

  filtroRelatorioManifestosPorUsuario(filtro): Observable<any> {

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_RELATORIO_MANIFESTOS_POR_USUARIO}`, filtro);

  }

  gerarPdfManifestosPorUsuario(filtro): Observable<any> {

    return this.http.post(
        `${environment.settings.api.url + URL_API.PATH_PDF_MANIFESTOS_POR_USUARIO}`,
        filtro,
        {
          responseType: 'arraybuffer'
        }
      );

  }

  gerarCsvManifestosPorUsuario(filtro): Observable<any> {

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_CSV_MANIFESTOS_POR_USUARIO}`, filtro, { responseType: 'text' });

  }

  filtroRelatorioManifestosPorOperador(filtro): Observable<any> {

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_RELATORIO_MANIFESTOS_POR_OPERADOR}`, filtro);

  }

  gerarCsvManifestosPorOperador(filtro): Observable<any> {

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_CSV_MANIFESTOS_POR_OPERADOR}`, filtro, { responseType: 'blob' as 'json' });

  }

  gerarPdfManifestosPorOperador(filtro): Observable<any> {

    return this.http.post(
        `${environment.settings.api.url + URL_API.PATH_PDF_MANIFESTOS_POR_OPERADOR}`,
        filtro,
        {
          responseType: 'arraybuffer'
        }
      );

  }

  filtroRelatorioManifestosPorUnidade(filtro): Observable<any> {

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_RELATORIO_MANIFESTOS_POR_UNIDADE}`, filtro);

  }

  gerarCsvManifestosPorUnidade(filtro): Observable<any> {

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_CSV_MANIFESTOS_POR_UNIDADE}`, filtro, { responseType: 'text' });

  }

  gerarPdfManifestosPorUnidade(filtro): Observable<any> {

    return this.http.post(
        `${environment.settings.api.url + URL_API.PATH_PDF_MANIFESTOS_POR_UNIDADE}`,
        filtro,
        {
          responseType: 'arraybuffer'
        }
      );

  }

  filtroRelatorioManifestosPorTema(filtro): Observable<any> {

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_RELATORIO_MANIFESTOS_POR_TEMA}`, filtro);

  }

  gerarCsvManifestosPorTema(filtro): Observable<any> {

    return this.http.post(`${environment.settings.api.url + URL_API.PATH_CSV_MANIFESTOS_POR_TEMA}`, filtro, { responseType: 'blob' as 'json' });

  }

  gerarPdfManifestosPorTema(filtro): Observable<any> {

    return this.http.post(
        `${environment.settings.api.url + URL_API.PATH_PDF_MANIFESTOS_POR_TEMA}`,
        filtro,
        {
          responseType: 'arraybuffer'
        }
      );

  }

  listarMunicipios() {

    return this.http.get(`${environment.settings.api.url + URL_API.PATH_RELATORIO_MUNICIPIOS}`);

  }

}
